import { Phone, FileText } from "lucide-react";
import { SITE, waLink } from "../lib/site";

const WhatsAppIcon = ({ size = 18 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    width={size}
    height={size}
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977.873 2.834 1.318 2.395 2.95 4.358 5.452 5.62.717.36 2.582 1.073 3.355 1.073.39 0 .79-.014 1.16-.187.575-.272 1.346-1.318 1.346-1.978 0-.13.014-.26-.015-.36-.072-.244-2.853-1.604-3.054-1.604z M16.072 2.625C8.722 2.625 2.745 8.6 2.745 15.95c0 2.583.737 5.078 2.137 7.232L2.5 30.25l7.317-2.354c2.066 1.13 4.4 1.7 6.74 1.7H16c7.346 0 13.395-6.05 13.395-13.4 0-3.555-1.305-6.94-3.7-9.484-2.4-2.553-5.628-3.962-9.205-3.962L16.07 2.625zm0 24.443h-.005a11.083 11.083 0 0 1-5.638-1.547l-.401-.244-4.18 1.348 1.36-4.082-.27-.412a10.853 10.853 0 0 1-1.7-5.92c0-6.066 4.95-11.018 11.027-11.018a11.115 11.115 0 0 1 7.835 3.245 11.108 11.108 0 0 1 3.226 7.79c0 6.067-5.057 11.018-11.124 11.018h-.13z" />
  </svg>
);

export const MobileStickyCTA = () => {
  return (
    <div
      data-testid="mobile-sticky-cta"
      className="md:hidden fixed bottom-0 left-0 right-0 z-40 px-3 pb-3 pt-2 bg-gradient-to-t from-black via-black/95 to-transparent"
    >
      <div className="grid grid-cols-3 gap-2">
        <a
          href={`tel:${SITE.phoneInternational}`}
          data-testid="msc-call"
          className="flex flex-col items-center justify-center gap-0.5 py-2.5 rounded-xl border border-[#D4AF37]/40 bg-black/60 backdrop-blur text-[#D4AF37] active:scale-95 transition"
        >
          <Phone size={18} />
          <span className="text-[10px] font-semibold tracking-wider">APPELER</span>
        </a>
        <a
          href="#contact"
          data-testid="msc-quote"
          className="flex flex-col items-center justify-center gap-0.5 py-2.5 rounded-xl btn-gold active:scale-95"
        >
          <FileText size={18} />
          <span className="text-[10px] font-semibold tracking-wider">DEVIS</span>
        </a>
        <a
          href={waLink()}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="msc-whatsapp"
          className="flex flex-col items-center justify-center gap-0.5 py-2.5 rounded-xl bg-[#25D366] text-white active:scale-95 transition"
        >
          <WhatsAppIcon size={18} />
          <span className="text-[10px] font-semibold tracking-wider">WHATSAPP</span>
        </a>
      </div>
    </div>
  );
};
